// @flow
import React, { Component } from 'react'
import { Grid, Row, Col } from 'react-flexbox-grid'
import { ScaleLoader } from 'react-spinners'
import { isMobile } from '../../utils'
import { buildUrl } from '../../services/linking'
import { post } from '../../services/utils'

export default class RequestChangeEmail extends Component {
  constructor (props) {
    super(props)
    this.state = {
      isLoading: true,
      error: '',
      title: '',
      message: '',
      url: buildUrl('LoggedOut'),
      isMobile
    }
  }

  async componentDidMount () {
    const {email = '', code = ''} = this.props.match.params
    try {
      const url = `${process.env.REACT_APP_API_REST_BASE}/security/change-email`
      await post(url, {email, code})
      this.setState({ title: 'Cambio de correo exitoso' })
      this.setState({ message: 'Sólo tenés que abrir la aplicación y usar tu nuevo correo.' })
    } catch (error) {
      this.setState({ error })
      this.renderErrorMessage(error)
    } finally {
      this.setState({ isLoading: false })
    }
  }

  renderErrorMessage () {
    switch (this.state.error) {
      case 'security-24':
        this.setState({title: '¡Oops!'})
        this.setState({message: 'No tenés solicitudes de cambio de correo en las últimas 24 horas.'})
        break
      case 'general-1':
        this.setState({title: '¡Oops!'})
        this.setState({message: 'Solicitud de cambio de correo inválida.'})
        break
      case 'general-3':
        this.setState({title: '¡Oops!'})
        this.setState({message: 'Este usuario no existe.'})
        break
      case 'security-18':
        this.setState({title: '¡Oops!'})
        this.setState({message: 'No has confirmado tu cuenta aún o tu cuenta está inactiva.'})
        break
      default:
        this.setState({title: '¡Oops!'})
        this.setState({message: 'Algo salio mal, intentá más tarde.'})
    }
  }

  render () {
    if (this.state.isLoading) {
      return (
        <Grid fluid>
          <Row center="sm">
            <Col xs={12} sm={12} md={12} lg={8}>
              <div className='mainContainer'>
                <Row center="xs">
                  <Col>
                    <div className='winkTopLogo'></div>
                  </Col>
                </Row>
                <Row center="xs">
                  <Col>
                    <div className='tittle'>
                      <ScaleLoader
                        color={'#123abc'}
                        loading={this.state.isLoading}
                      />
                    </div>
                  </Col>
                </Row>
                <Row center="xs">
                  <Col>
                    <div className='message'>Estamos procesando tus datos...</div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Grid>
      )
    }

    return (
      <Grid fluid>
        <Row center="sm">
          <Col xs={12} sm={12} md={12} lg={8}>
            <div className='mainContainer'>
              <Row center="xs">
                <Col>
                  <div className='winkTopLogo'></div>
                </Col>
              </Row>
              <Row center="xs">
                <Col>
                  <div className='tittle'>{this.state.title}</div>
                </Col>
              </Row>
              <Row center="xs">
                <Col>
                  <div className='message'>{this.state.message}</div>
                </Col>
              </Row>
              {!this.state.error && this.state.isMobile.any() && <Row center="xs">
                <Col>
                  <a href={this.state.url} className='btn-primary-outline'>ABRIR EN WINK</a>
                </Col>
              </Row>}
              <Row center="xs">
                <Col xs={12} md={12}>
                  <div className='warningMessage'>Sos parte de la familia Wink. Si necesitás cualquier cosa no dudes
                    contactarnos a través del chat de soporte del App. Nuestro <a href="#">Centro de Soporte</a> siempre
                    está para ayudarte.
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Grid>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/RequestChangeEmail/index.js